import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Select } from "../../common";
import { useDispatch, useSelector } from "react-redux";
import { useGetMagicTokenMutation } from "../../../store/Company/companyApiSlice";
import { ReactComponent as Spinner } from "../../../assets/icons/orangeSpinner.svg";
import { ReactComponent as TrevexGptLogo } from "../../../assets/icons/TrevexGptLogo.svg";
import { ReactComponent as KHubLogo } from "../../../assets/icons/k-hub-logo.svg";
import { ReactComponent as RocketIcon } from "../../../assets/icons/rocketIcon.svg";
export const GPT_prompt = ({ to = "" }) => {
    const { token } = useSelector((state) => state.auth);
    const [magicToken, setMagicToken] = useState();
    const [getMagicToken, { isLoading, error }] = useGetMagicTokenMutation();

    const handleRedirectToGpt = (token) => {
        if (to === "gpt") {
            const url = token
                ? `${process.env.REACT_APP_GPT_URL}/login?token=${token}`
                : `${process.env.REACT_APP_GPT_URL}/gpt-prompts`;
            window.open(url, "_blank");
        } else if (to === "article") {
            const url = `${process.env.REACT_APP_K_HUB_URL}/magic/${token}`;
            window.open(url, "_blank");
        } else {
            return null
        }
    };

    const getMagicTokenData = async () => {
        const tokenData = await getMagicToken({ token });
        if (tokenData?.data?.token) {
            setMagicToken(tokenData?.data);
            handleRedirectToGpt(tokenData?.data?.token)
        } else if (tokenData?.error) {
            handleRedirectToGpt(false)
        }
    }

    useMemo(() => {
        if (token && to !== "") {
            getMagicTokenData();
        }
    }, [token, to]);
    return (
        <Card classes="w-full">
            <div className="w-full max-w-[900px] flex flex-row items-center justify-between m-auto">
                <div className="flex flex-col h-[calc(100vh-200px)] items-center justify-center">
                    {to === "gpt" ? <TrevexGptLogo /> : <KHubLogo />}
                    {isLoading && <p className="text-[#686262] text-[24px]">Hold On!</p>}
                    <div className="text-[17px] max-w-[400px] mt-2">
                        {isLoading ? <div className="flex flex-row justify-center items-center gap-2"><Spinner /><span>You’re being redirected to another page</span></div> : <div>You’ve been redirected to the another page in a new tab.</div>}
                        <p>If you’re not redirected in a few seconds,<span onClick={() => { getMagicTokenData() }} className="text-[#2B6483] cursor-pointer font-bold">{" click here "}</span>to proceed manually.</p>
                    </div>
                </div>
                <RocketIcon />
            </div>
        </Card>
    );
};